<template>
  <div v-if="list && list.length" class="new-promotion">
    <transition-group class="carousel" name="fade-new-promotion" tag="div">
      <div class="carousel-item" v-for="(item, idx) in list" :key="item.id" v-show="idx === current">
        <img class="new-tag" :src="newIcon" />
        <img class="main-img" :src="item.images" />
        <div class="title" :title="item.title" @mouseenter="stopCarousel" @mouseleave="startCarousel">{{ item.title }}</div>
        <div class="desc-box" @mouseenter="stopCarousel" @mouseleave="startCarousel">
          <div class="desc" :title="item.description">{{ item.description }}</div>
        </div>
        <div class="btn">
          <Button type="primary" @click="onBtnClick(item)">
            <strong>立即体验</strong>
          </Button>
        </div>
      </div>
    </transition-group>
    <div v-if="list.length > 1" class="indicator">
      <Icon type="ios-arrow-back" @click="onIndicator(-1)" />
      <span>{{ current + 1 }}/{{ list.length }}</span>
      <Icon type="ios-arrow-forward" @click="onIndicator(1)" />
    </div>
  </div>
</template>

<script>
import api from '../../../api/home';
import newIcon from '../../../assets/img/ico_new.png';
import moment from 'moment';

export default {
  name: 'new-promotion',
  data() {
    return {
      current: 0,
      list: null,
      newIcon,
    };
  },
  created() {
    this.getPromotionList();
  },
  methods: {
    getPromotionList() {
      api.getPromotedModules().then((res) => {
        this.list = res;
        if (this.list.length > 1) {
          this.startCarousel();
        }
      });
    },
    startCarousel() {
      if (this.carouselTimer) {
        clearTimeout(this.carouselTimer);
        this.carouselTimer = null;
      }
      this.carouselTimer = setTimeout(() => {
        this.carouselTimer = null;
        this.onIndicator(1);
      }, 5000);
    },
    stopCarousel() {
      if (this.carouselTimer) {
        clearTimeout(this.carouselTimer);
        this.carouselTimer = null;
      }
    },
    onIndicator(num) {
      this.current += num;
      if (this.current < 0) {
        this.current = this.list.length - 1;
      } else if (this.current >= this.list.length) {
        this.current = 0;
      }
      this.startCarousel();
    },
    onBtnClick(item) {
      item.buriedPointCode && ccutils.buriedPonitUpload({
        eventInfo: {
          eventCode: item.buriedPointCode, // 事件编码
          eventTypeWeb: 'click',
          entryTime: moment().format('YYYY-MM-DD HH:mm:ss'),
          currentUrl: location.href,
          referUrl: document.referrer,
        }
      });
      window.open(item.linkUrl, '_blank');
      this.startCarousel();
    },
  },
};
</script>

<style lang="scss" scoped>
.new-promotion {
  position: relative;
  width: 256px;
  min-height: 254px;
  margin-left: 16px;
  background: #fff;
  border-radius: 8px;
  overflow: hidden;
}
.carousel {
  position: absolute;
  z-index: 1;
  width: 100%;
  height: 100%;
}
.carousel-item {
  display: flex;
  flex-direction: column;
  position: relative;
  height: 100% !important;
  user-select: text;
}
.main-img {
  width: 100%;
  height: 144px;
  object-fit: cover;
}
.new-tag {
  position: absolute;
  top: 8px;
  left: 8px;
  z-index: 2;
  width: 26px;
  height: 14px;
  border: none;
}
.title {
  flex-shrink: 0;
  margin: 8px;
  font-weight: 600;
  font-size: 16px;
  color: #333333;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  word-break: break-all;
}
.desc-box {
  position: relative;
  min-height: 22px;
  margin: 0 8px;
  overflow: hidden;
  &::after {
    content: '';
    position: absolute;
    bottom: 0;
    left: 0;
    z-index: 2;
    width: 100%;
    height: 8px;
    background: linear-gradient(to bottom, rgba(255, 255, 255, 0), #fff);
  }
}
.desc {
  font-size: 13px;
  color: #7F7F7F;
  white-space: pre-line;
}
.btn {
  margin: 8px;
}
.indicator {
  position: absolute;
  right: 12px;
  bottom: 12px;
  z-index: 3;
  display: flex;
  align-items: center;
  color: #7f7f7f;
  .ivu-icon {
    font-size: 14px;
    cursor: pointer;
    &:hover {
      color: #f90;
    }
  }
  span {
    margin: 0 12px;
    font-size: 12px;
  }
}
</style>
<style lang="scss">
.new-promotion {
  .fade-new-promotion-enter-active,
  .fade-new-promotion-leave-active {
    transition: opacity 0.5s, transform 0.5s;
  }
  .fade-new-promotion-enter,
  .fade-new-promotion-leave-to {
    opacity: 0;
  }
  .fade-new-promotion-leave-active {
    position: absolute; /* 避免列表跳动 */
  }
}
</style>
